import React from 'react';
import { Configurations } from '../../Utils/Configurations';





class IdProducts extends React.Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();
    }

    render() {

        const {
            handleProductChange,
            produtos,
            selectedProduct,
        } = this.props;

        return (
            <div className="form-group m-0">
                <label htmlFor="ddlProduto">Produto</label>
                <select id="ddlProduto" name="selectedProduct" className="form-control" value={selectedProduct || ''} onChange={handleProductChange}>
                    <option value=""></option>
                    {produtos.map((item, index) => {
                        return (
                            <option key={index} value={item.idProduto}>{item.nome} (ID {item.idProduto})</option>
                        )
                    })}
                </select>
            </div>
        )
    }
}


export default IdProducts;